import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import * as React from "react"

export const SIGN_IN_FORM_SUBMITTED = "signInForm/submitted"

export const signInFormSubmitted = (email: string, password: string) => ({
    type: SIGN_IN_FORM_SUBMITTED,
    payload: {
        email: email,
        password: password,
    },
})

export const SIGN_IN_REQUESTED = "signIn/requested"

export const signInRequested = (email: string, password: string) => ({
    type: SIGN_IN_REQUESTED,
    payload: {
        email: email,
        password: password,
    },
})

export const SIGN_IN_SUCCESS = "signIn/success"

export const signInSuccess = (session: string, role: string, userId: string, userEmail: string) => ({
    type: SIGN_IN_SUCCESS,
    payload: {
        session: session,
        role: role,
        userId: userId,
        userEmail: userEmail,
    },
})

export const STORE_SIGN_IN_AUTH_DATA = "signIn/storeData"

export const storeSignInAuthData = (session: string, role: string, userId: string) => ({
    type: STORE_SIGN_IN_AUTH_DATA,
    payload: {
        session: session,
        role: role,
        userId: userId,
    },
})

export const SIGN_IN_FAILURE = "signIn/failure"

export const signInFailure = (error: any, message: Maybe<string> | Maybe<React.ReactNode>, type?: string | null) => ({
    type: SIGN_IN_FAILURE,
    payload: {
        error: error,
        message: message,
        type: type,
    },
})
